Attributes of the conflicting position opening.
